import ASScroll from '@ashthornton/asscroll';

import Accordion from './_modules/Accordion';
import AreasOfExpertise from './_modules/AreasOfExpertise';
import BackgroundText from './_modules/BackgroundText';
import Challenge2030 from './_modules/Challenge2030';
import Cursor from './_modules/Cursor';
import FadeOut from './_modules/FadeOut';
import Featured from './_modules/Featured';
import GrayBackground from './_modules/GrayBackground';
import HeroHome from './_modules/HeroHome';
import HowWeWork from './_modules/HowWeWork';
import ImageWithHotspots from './_modules/ImageWithHotspots';
import Intro from './_modules/Intro';
import LeadershipGrid from './_modules/LeadershipGrid';
import Menu from './_modules/Menu';
import MobileActiveItems from './_modules/MobileActiveItems';
import OurProcess from './_modules/OurProcess';
import ParallaxImage from './_modules/ParallaxImage';
import PhotoGallery from './_modules/PhotoGallery';
import PlayWhenScrolledTo from './_modules/PlayWhenScrolledTo';
import PostsGrid from './_modules/PostsGrid';
import ProgressBar from './_modules/ProgressBar';
import StickySection from './_modules/StickySection';
import ValuesCarousel from './_modules/ValuesCarousel';
import VideoModal from './_modules/VideoModal';
import WorkGrid from './_modules/WorkGrid';

import FixStickyHover from './_utils/FixStickyHover';
import LoadLazyImages from './_utils/LoadLazyImages';
import CopyClipboard from './_utils/CopyClipboard';
import ReadTime from './_utils/ReadTime';
function init() {

	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	
	// Set various browser/environment classes
	document.documentElement.classList.remove('no-js');
	document.documentElement.classList.add('js');
	document.documentElement.setAttribute('data-useragent', navigator.userAgent);

	// ASScroll
	// window.scrollTo(0, 0);

	const asscroll = new ASScroll({
		reset: true,
		touchScrollType: 'transform'
	});
	asscroll.enable();

	if (window.location.hash) {
		window.addEventListener('load', () => {
			let anchorElement = document.getElementById(window.location.hash.substr(1))
			if (anchorElement) {
				asscroll.scrollTo(anchorElement.offsetTop)
			}
		})
	}

	// Cursor
	const cursor = new Cursor();
	cursor.enable();

	// // FadeOut
	// const fadeOut = new FadeOut();
	// fadeOut.enable();

	// Menu
	const menu = new Menu(asscroll);
	menu.enable();

	// Featured
	let elements = document.querySelector('.featured');
	if (elements) {
		const featured = new Featured(asscroll, menu, elements);
		featured.enable();
	}

  CopyClipboard();
  ReadTime();
	// LoadLazyImages
	LoadLazyImages();

	// ProgressBar
	const progressBar = new ProgressBar(asscroll);
	progressBar.enable();

	// Accordion
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-service-listing--item'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new Accordion(
				element, 
				'.section-service-listing--item-title', 
				'.section-service-listing--item-trigger', 
				'.section-service-listing--item-panel', 
				'.section-service-listing--item-image'
			);
			item.enable();
		});
	}
	elements = null;

	// AreasOfExpertise
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-areas-of-expertise'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new AreasOfExpertise(asscroll, element);
			item.enable();
		});
	}
	elements = null;

	// BackgroundText
	elements = Array.prototype.slice.call(document.querySelectorAll('.has-background-text'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new BackgroundText(asscroll, element);
			item.enable();
		});
	}
	elements = null;

	// GrayBackground
	elements = Array.prototype.slice.call(document.querySelectorAll('.background-is-gray'), 0);
	if (elements) {
		const grayBg = new GrayBackground(asscroll, elements);
		grayBg.enable();
	}
	elements = null;

	// HeroHome
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-hero-home'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new HeroHome(asscroll, element);
			item.enable();
		});
	}
	elements = null;

	// HowWeWork
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-how-we-work'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new HowWeWork(asscroll, element);
			item.enable();
		});
	}
	elements = null;

	// StickySection - General
	elements = Array.prototype.slice.call(document.querySelectorAll('.sticky-scroll'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new StickySection(asscroll, element, element.querySelector('.sticky-fixed'));
			item.enable();
		});
	}
	elements = null;

	// StickySection - Leadership Page
	elements = Array.prototype.slice.call(document.querySelectorAll('.single-leadership-page--scroll'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new StickySection(asscroll, element, element.querySelector('div'));
			item.enable();
		});
	}
	elements = null;

  // // StickySection - Insight Detail
  // elements = Array.prototype.slice.call(document.querySelectorAll('.section-insight-detail--right'), 0);
  // if (elements) {
  //   elements.forEach((element) => {
  //     const item = new StickySection(asscroll, element, element.querySelector('.sticky-wrap'));
  //     item.enable();
  //   });
  // }
  elements = null;

	// ImageWithHotspots
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-image-with-hotspots'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new ImageWithHotspots(element);
			item.enable();
		});
	}
	elements = null;

	// LeadershipGrid
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-leadership-grid.dynamic'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new LeadershipGrid(asscroll, cursor, element);
			item.enable();
		});
	}
	elements = null;

	// MobileActiveItems
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-sustainability-commitments'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new MobileActiveItems(element, '.section-sustainability-commitments--card');
			item.enable();
		});
	}
	elements = null;

	// OurProcess
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-our-process'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new OurProcess(element);
			item.enable();
		});
	}
	elements = null;

	// ParallaxImage
	elements = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-image]'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new ParallaxImage(asscroll, element, element.getAttribute('data-parallax-image'));
			item.enable();
		});
	}
	elements = null;

	// PhotoGallery
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-photo-gallery'), 0);
	if (elements) {
		elements.forEach((element) => {
			new PhotoGallery(element);
		});
	}
	elements = null;

	// PlayWhenScrolledTo
	elements = Array.prototype.slice.call(document.querySelectorAll('.play-when-scrolled-to'), 0);
	if (elements) {
		elements.forEach((element) => {
			new PlayWhenScrolledTo(asscroll, element);
		});
	}
	elements = null;

	// PostsGrid
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-posts-grid.dynamic'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new PostsGrid(asscroll, cursor, element);
			item.enable();
		});
	}
	elements = null;

	// ValuesCarousel
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-values-carousel'), 0);
	if (elements) {
		elements.forEach((element) => {
			new ValuesCarousel(element);
		});
	}
	elements = null;

	// VideoModal
	const videoModal = new VideoModal(cursor);
	videoModal.enable();

	// WorkGrid
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-work-grid.dynamic'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new WorkGrid(asscroll, cursor, element);
			item.enable();
		});
	}
	elements = null;

	// Challenge2030
	elements = Array.prototype.slice.call(document.querySelectorAll('.section-2030-challenge'), 0);
	if (elements) {
		elements.forEach((element) => {
			const item = new Challenge2030(asscroll, element);
			item.enable();
		});
	}
	elements = null;

	// Trigger window to resize event to fix ASScroll's height issues
	setTimeout(function(){
		window.dispatchEvent(new Event('resize'));
	}, 200);

}

function fontsLoaded() {

	// Fix sticky hovers on mobile
	FixStickyHover();

	// init page after intro
	new Intro(init);
}


function pageLoaded() {

	// Remove old event handler
	document.removeEventListener('DOMContentLoaded', pageLoaded);

	// Check to see if @font-face files are loaded
	if (document.fonts === undefined) {
		fontsLoaded();
	} else if (document.fonts.status === 'loaded') {
		fontsLoaded();
	} else {
		// NOTE: fonts.onloadingdone isn't reliably called within Safari
		let loaded = false;
		document.fonts.ready.then(() => {
			if (loaded) {
				return;
			}
			loaded = true;
			fontsLoaded();
		});
	}
}


// Wait for page's assets to load
if (document.readyState === 'complete') {
	pageLoaded();
} else {
	document.addEventListener('DOMContentLoaded', pageLoaded);
}

window.addEventListener('pageshow', () => {
	try {

		if (localStorage.getItem('current_url')) {
			localStorage.setItem('previous_url', localStorage.getItem('current_url'))
			
		}

		localStorage.setItem('current_url', location.href)
	} catch(e) {

	}
})
